import styles from './ProgressBar.module.css';

interface ProgressBarProps {
  completed: number;
  total: number;
}

export function ProgressBar({ completed, total }: ProgressBarProps) {
  const percentage = total > 0 ? Math.round((completed / total) * 100) : 0;

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <span className={styles.label}>Progress</span>
        <span className={styles.count}>
          {completed}/{total} tasks
        </span>
      </div>
      <div className={styles.track}>
        <div 
          className={styles.fill} 
          style={{ width: `${percentage}%` }}
        />
      </div>
      <span className={styles.percentage}>{percentage}% complete</span>
    </div>
  );
}


